module.exports = __webpack_public_path__ + "img/img_left_nav_bonus.5afd8d1d.svg";